<template>
    <internal>
        <card-header :title="'Course Year: '+branchcourseyear.courseyear.title+' - '+branchcourseyear.courseyear.course.title" />
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg" >
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add Course EMI</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Title'"/>
                            <breeze-input required v-model="form.title" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.title:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Amount'"/>
                            <breeze-input required type="number" v-model="form.amount" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.amount:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'End Date'"/>
                            <breeze-input type="date" required v-model="form.end_date" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.end_date:''" />
                        </div>
                        <div class="col-span-2 sm:col-span-2">
                            <breeze-label :required="true" :value="'Due Date'"/>
                            <breeze-input type="date" required v-model="form.due_date" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.due_date:''" />
                        </div>
                        <div class="">
                            <breeze-label :value="'Status'"/>
                            <breeze-checkbox v-model="form.status" :checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <button-link :href="route('internal.courseyear.fee.list',[branchid,branchcourseyear.id])" class="bg-red-500 mr-4 hover:bg-red-400">Cancel</button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception />
                </form>
            </div>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import InputCheckbox from '@/Components/InputCheckbox'
    import BreezeInputError from '@/Components/InputError'
    import ButtonLink from '@/Components/ButtonLink'
    import Exception from '@/Components/Exception'
    import Loading from '@/Components/Loading'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Internal,
            ButtonLink,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeInputError,
            BreezeButton,
            Exception,
            Loading,
            InputCheckbox,
            CardHeader
        },
        props:['branchcourseyear'],
        data(){
            return{
                form: useForm({
                    title: '',
                    amount: '',
                    end_date: '',
                    due_date: '',
                    status: true,
                }),
                branchid:localStorage.branchId
            }
        },
        methods: {
            submitForm() {
                this.form.post(route('internal.courseyear.fee.store',[this.branchid,this.branchcourseyear.id]),{
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                });
            },
        },
    }
</script>
